import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19.649 4.26a1.081 1.081 0 1 0-1.41 1.643c1.532 1.314 2.598 3.561 2.598 6.187 0 2.621-1.064 4.867-2.593 6.183a1.082 1.082 0 0 0 1.41 1.64C21.71 18.144 23 15.273 23 12.09c0-3.188-1.292-6.061-3.352-7.83m-9.976.312c1.348-1.143 3.413-.183 3.413 1.582V18.02c0 1.765-2.065 2.724-3.413 1.582l-3.642-3.087H4.073A2.074 2.074 0 0 1 2 14.442v-4.71c0-1.145.928-2.074 2.073-2.074H6.03zm1.25 1.777L7.127 9.565a1.08 1.08 0 0 1-.7.257H4.164v4.53h2.265c.256 0 .503.09.699.256l3.796 3.217zm4.169 1.217a1.08 1.08 0 0 1 1.49-.34c1.519.955 2.453 2.824 2.453 4.866 0 2.04-.934 3.911-2.457 4.858a1.081 1.081 0 1 1-1.142-1.837c.78-.486 1.436-1.593 1.436-3.021s-.655-2.54-1.44-3.034a1.08 1.08 0 0 1-.34-1.492",
      class: "hidden joe-be:block joe:block qmusic:block"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M2 8.58v6.84h4.667l5.833 5.702V2.878L6.667 8.579zM17.75 12c0-2.018-1.19-3.751-2.917-4.595v9.179C16.56 15.75 17.75 14.018 17.75 12M14.833 2v2.349c3.372.98 5.834 4.036 5.834 7.651s-2.462 6.67-5.834 7.651V22C19.512 20.962 23 16.88 23 12s-3.488-8.962-8.167-10",
      class: "hidden willy:block",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }